import React, { Component } from 'react';
import styled from 'styled-components';
import { Dropdown, Menu } from 'antd';
const Outer = styled.div `
  display: flex;
  .child {
    flex:  1;
    /** footer 子元素样式 (包括更多) */
    .optLinkbtn, .ant-dropdown-link.ant-dropdown-trigger {
      width: 100%;
      height: 100%;
      display:flex;
      justify-content: center;
      align-items: center;
      color: rgba(0, 0, 0, 0.45);
    }
    .ant-dropdown-link {
      &:before {
        content: '';
        display: inline-block;
        width: 14px;
        height: 14px;
        margin: 1px 8px 0 0;
        background-image:  url(${require('@/assets/SceneManage/moreBtn@3x.png')});
        background-size: 100% 100%;
      }
    }
    .ant-dropdown {
      z-index: 100;
    }
  }
  .child:not(:last-child){
    &:after{
      content: '';
      display: inline-block;
      width:1px;
      height:16px;
      background: #e8e8e8;
    }
  }
  /* React.Children 无法filter null 只能不渲染null 的补救措施 */
  align-items: center;
  a, .ant-dropdown-link.ant-dropdown-trigger {
      flex: 1;
      height: 16px;
      display:flex;
      justify-content: center;
      align-items: center;
      color: rgba(0, 0, 0, 0.45);
    }
  .ant-dropdown-link {
    &:before {
      content: '';
      display: inline-block;
      width: 14px;
      height: 14px;
      margin: 1px 8px 0 0;
      background-image:  url(${require('@/assets/SceneManage/moreBtn@3x.png')});
      background-size: 100% 100%;
    }
  }
  & > a.optLinkbtn:not(:last-of-type){
    border-right: 1px solid #e8e8e8;
  }
  .ant-dropdown  .menu_outer a {
    height: 100%;
    padding: 5px 12px;
    line-height: 22px;
    &:hover {
      background-color: #fff1e6;
    }
  }
`;
class FooterOpt extends Component {
    constructor() {
        super(...arguments);
        this.renderChildren = () => {
            const { maxShowNum = 3, children } = this.props;
            const childrenLen = React.Children.count(children);
            if (childrenLen > 0) {
                let finalRenderChildren = children;
                // 如果超过最大展示数，从最大展示数中插入更多下拉框
                if (childrenLen > maxShowNum) {
                    const children2 = React.Children.toArray(children);
                    const preRender = children2.slice(maxShowNum - 1);
                    children2.splice(maxShowNum - 1, childrenLen - maxShowNum + 1, this.renderMore(preRender));
                    finalRenderChildren = children2;
                }
                return (<>
        {React.Children.map(finalRenderChildren, (child) => (
                /* React.Children 无法filter null 只能不渲染null 的补救措施 不嵌套外层 */
                // <div className="child flex__row-center">
                // {child}
                // </div>
                child))}
        </>);
            }
            return null;
        };
        this.renderMore = (children) => {
            const menu = (<Menu className="menu_outer">
        {React.Children.map(children, (child) => (
            /* React.Children 无法filter null 只能不渲染null 的补救措施 不嵌套外层 */
            // <Menu.Item>
            // {child}
            // </Menu.Item>
            child))}
      </Menu>);
            return (<Dropdown overlay={menu} getPopupContainer={(triggerNode) => {
                return triggerNode.parentNode;
            }}>
        <a className="ant-dropdown-link" href="#">
          更多
        </a>
      </Dropdown>);
        };
    }
    render() {
        const { className, style, children } = this.props;
        const childrenLen = React.Children.count(children);
        return (
        // 判断有没有孩子， 如果没有就不展示了
        childrenLen !== 0 ?
            (<Outer className={className} style={style}>
          {this.renderChildren()}
      </Outer>) : null);
    }
}
export default FooterOpt;
